<div class="wrapper">
    <div class="link p-2">
        {{ shareLink }}
    </div>
    <div class="copy-link" (click)="copyLink('hidden-link')">Copy link</div>
</div>
